import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    side_menu_container: {
        backgroundColor: `${theme.palette.secondary.light}`,
        boxSizing: 'border-box',
        display: 'flex',
        zIndex: 2,
        justifyContent: "space-between",
        position: 'relative',
        padding: '8px',
    },
    menu_items_container_top: {
        display: 'flex',
        backgroundColor: theme.palette.secondary.light,
        position: 'absolute',
        boxSizing: 'border-box',
        top: '55px',
        width: "242px",
        left: "-8px",
        zIndex: 10
    },
    menu_items_container: {
        display: 'flex',
        backgroundColor: theme.palette.secondary.light,
        position: 'absolute',
        flexDirection: "column",
        boxSizing: 'border-box',
        top: '51px',
        width: "250px",
        left: "-8px",
        maxHeight: 'calc(100vh - 60px)',
        overflowY: 'auto',
        zIndex: 10,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: theme.palette.secondary.dark,
            borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.primary.main,
            borderRadius: '3px',
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
            },
        },
    },
    menu_item_title: {
        display: 'flex',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        alignItems: 'center',
        color: theme.palette.grey[300],
        fontSize: '16px',
        padding: '8px 14px',
        minHeight: '40px',
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary.light,
            cursor: 'pointer',
        },
        "& svg": {
            fontSize: '20px',
            marginRight: '16px',
            flexShrink: 0
        },
    },
    title_with_children: {
        width: '100%',
        backgroundColor: theme.palette.secondary.dark,
        borderRadius: 0,
        color: theme.palette.common.white,
        minHeight: '44px',
        padding: '10px 14px',
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary.light,
            cursor: 'pointer'
        },
    },
    title_label_with_children: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: '8px',
        "& > div:first-child": {
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        "& > svg": {
            flexShrink: 0
        }
    },
    label_container: {
        paddingLeft: '26px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    menu_item_children: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.secondary.main,
        paddingTop: '4px',
        paddingBottom: '4px'
    },
    title_with_children_active: {
        fontWeight: 800,
        color: theme.palette.primary.main
    },
    menu_button_container: {
        position: 'relative',
        boxSizing: 'border-box',
    },
    menu_button: {
        cursor: 'pointer',
        borderRadius: '8px',
        boxSizing: 'border-box',
        border: `1px solid transparent`,
        "& svg": {
            fontSize: '40px',
            color: theme.palette.common.white,
        },
        "&:hover": {
            border: `1px solid ${theme.palette.common.white}`
        }
    },
    menu_item_container: {
        minHeight: '45px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textDecoration: 'none',
        padding: '0',
        color: theme.palette.secondary.light,
        fontSize: '20px',
        boxSizing: 'border-box',
        "&:hover": {
            backgroundColor: `${theme.palette.secondary.main}d1`,
            cursor: 'pointer',
            color: theme.palette.common.white
        },
        "& svg": {
            fontSize: '30px',
        },
        "& div": {
            flexGrow: 1
        }
    },
    active: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontWeight: 800,
        borderLeft: `4px solid ${theme.palette.primary.light}`,
        paddingLeft: '10px'  
    },
    main_action_container: {
        display: 'flex',
        height: '50px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        boxSizing: 'border-box'
    },
    user_info_container: {
        color: theme.palette.common.white,
        width: 'fit-content',
        flexWrap: 'nowrap',
        marginRight: '8px'
    }
}));

export {useStyles}
